<template>
  <div class="principal">
    <menu-terceiros/>
    <header class="w3-container w3-white w3-center">
      <div class="w3-row-padding w3-center">
        <h1 
          class="texto-vermelho" 
          style="font-size: 48px">
          Olá
        </h1>

        <div class="w3-col s12" style="margin-bottom: 15px;">
          <div 
            class="circulo-letra w3-border w3-center w3-circle">
            {{getPrimeiraLetraNome(usuario_logado.nome)}}
          </div>
        </div>
  
        <div class="w3-col">
          <div class="w3-display-container" style="height:5rem;">
            <div style="align-content: left">
              
              <span class="texto-cinza" style="font-size: 16px" v-cloak>
                {{usuario_logado.cadastro_id}} - {{usuario_logado.nome}}
              </span>
              
              <div class="w3-col">
                <strong v-if="usuario_logado.tipo_autenticacao == 'MOT'" class="texto-preto"> 
                  {{empresa_logada.empresa_id + ' - ' + empresa_logada.nome_fantasia}}
                </strong>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </header>
  
    <div 
      class="w3-main" 
      style="margin-top:30px;" 
      id="principal">
      <div class="w3-container">
        <div class="w3-row-padding w3-center">
          
          <div class="w3-col s12" v-if="usuario_logado.tipo_autenticacao == 'MOT'">
            <router-link
              to="/manifestos"
              class="w3-button w3-large w3-hover-theme botao-menu-principal">
              <i class="fa fa-truck"/> Manifestos
            </router-link>
          </div>

          <div class="w3-col s12" v-if="usuario_logado.tipo_autenticacao == 'FRN'">
            <router-link
              to="/cotacoes-fornecedores"
              class="w3-button w3-large w3-hover-theme botao-menu-principal">
              <i class="fa fa-cart-arrow-down"/> Cotações 
              <span class="texto-vermelho" v-if="usuario_logado.quantidade_cotacoes"> {{ '(' + usuario_logado.quantidade_cotacoes + ')' }} </span>
            </router-link>
          </div>
          
          <div class="w3-col s12">
            <button 
              @click="logout()" 
              class="w3-button w3-large w3-hover-theme botao-menu-principal">
              <i class="fa fa-sign-out-alt fa-fw"/> Sair
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MenuTerceiros from "@/components/MenuTerceiros";
  import RLogout from "@/components/Rest/RLogout.js";
  import RSessao from "@/components/Rest/RSessao.js";
  import toastr from 'toastr';
  export default {
    name: "PrincipalTerceiros",
    components: {
      MenuTerceiros
    },
    data() {
      return {
        api: process.env.API,
        empresa_logada: {},
        usuario_logado: {},
      };
    },
    methods: {
      async buscarDadosSessaoTerceiro() {
        try {
          let retorno = await RSessao.buscarDadosSessaoTerceiros(this.axios);
      
          if (retorno.houve_erro == 'S'){
            this.logando = false;
            throw new Error(retorno.mensagem);
          }

          // Dados de usuário
          this.usuario_logado = JSON.parse(JSON.stringify(retorno.dados.usuario_logado));
          
          // Dados de empresa
          if (retorno.dados.empresa_logada){
            this.empresa_logada = JSON.parse(JSON.stringify(retorno.dados.empresa_logada)); 
          }
        } catch (error) {
          toastr.error("Sessão não foi iniciada corretamente, motivo: " + error.message);
        }
      },

      async logout(){  
        try {
          await RLogout.realizarLogout(this.axios);
          window.location.href = "/login-terceiros";
        } catch (error) {
          console.log('Erro ao realizar logout: ' + JSON.stringify(error));
        }
      },

      getPrimeiraLetraNome(nome){
        if (nome){
          return nome.substr(0, 1);
        } else {
          return '?';
        }
      },
    },
    async created() {
      await this.buscarDadosSessaoTerceiro();
    }
  };
</script>

<style scoped>
  @media screen and (min-width: 1200px){    
    .botao-menu-principal:hover span{color: #fff !important}
  }

  .circulo-letra {
    width: 100px; 
    height: 100px; 
    background-color: #9c1d1c; 
    color: #f7f7f7; 
    background-size: cover; 
    font-weight: bold; 
    font-size: 60px; 
    display: inline-block; 
    padding-top: 1px;
    border: 3px solid #ebe6e6!important; 
    box-shadow: #6b6b6b 2px 2px 5px 2px;
    margin-bottom: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/PrincipalTerceiros.vue